import React from "react";
import { Flex } from "@chakra-ui/react";
import { type NavTagProps } from "./data";

export function SubNavTag({ text, color }: NavTagProps) {
  return (
    <Flex
      as="span"
      align="center"
      bg={`new.${color}.700`}
      borderRadius="huger"
      color="brand.text.dark"
      height="small"
      justify="center"
      textStyle="caption2"
      fontWeight="semibold"
      px="10px"
    >
      {text}
    </Flex>
  );
}
